// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--eMWRA";
export var columns = "footer-module--columns--2tQlj";
export var columnsReverse = "footer-module--columnsReverse--2LhR7";
export var bmc = "footer-module--bmc--1U2Qd";